import { Text } from '@/components/widgets/blog/Paragraph.styles'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

type ParagraphProps = {
  text: string
}

const Paragraph: React.FC<ParagraphProps> = ({ text }) => {
  // Todo: currently Text is a div to allow any HTML
  // Need to create a List component and convert this back to p
  return (
    <Text>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
    </Text>
  )
}

export default Paragraph
